module.exports = __webpack_public_path__ + "static/media/data_analytics.510c6064.jpg";